import type { FaireProductEntity } from "../../entity_types/product";

export const p_ma5563wkpd: FaireProductEntity = {
  token: "p_ma5563wkpd",
  type: "product",
  name: "OY Large Coffee Table in Dark",
  brandToken: "b_8qfvgpu7nc",
  brandName: "OYOY LIVING DESIGN",
  imageUrl:
    "https://cdn.faire.com/fastly/731dcb0ec9654189f3a67359a7dd6d6e74e9304d21eb0fbf19040bcc85174df0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/30e29d168b4b57328720b5813f62d54af3e330175dd2950ba6236c3b621d5b75.jpeg",
    "https://cdn.faire.com/fastly/223384dcf2bc3892bfa56ce31adcc3b4c83090d0783db59290712f73bb8bd896.jpeg",
    "https://cdn.faire.com/fastly/ce995950e451ea387b7663f01b537fce6f4862ba3935ae4e2c50cba3ab656670.jpeg",
  ],
  priceDollars: 323,
  description:
    "Inspired by sculptural minimalism the OY Coffee Table is designed with an eye on simplicity with an edge. The table is crafted in high-quality ash treated with a stained oil giving a depth and warmth which emphasizes the elegant and natural veining of the wood.",
  tags: [],
  msrpDollars: 646,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-06T00:00:00.000Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
